'use client';
// Import client-side i18next instance
import '@/lib/i18n/client';
import { useTranslation } from 'react-i18next';
import styles from './faqs.module.css';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

// Italian Market FAQs Component
function ItalianMarketFaqs() {
  const { t } = useTranslation();

  return (
    <>
      <section className={styles.header}>
        <h1 className={styles.heading}>{t('merchants.faqs.italianMarket.heading')}</h1>
        <p className={styles.subheading}>{t('merchants.faqs.italianMarket.subheading')}</p>
      </section>

      <div className={styles.faqContainer}>
        {/* Eligible Products FAQ */}
        <div className={styles.faqItem}>
          <h2 className={styles.faqQuestion}>
            {t('merchants.faqs.italianMarket.eligibleProducts.question')}
          </h2>
          <div className={styles.faqAnswer}>
            <p>{t('merchants.faqs.italianMarket.eligibleProducts.answer.part1')}</p>
            <p>{t('merchants.faqs.italianMarket.eligibleProducts.answer.part2')}</p>
            <ul className={styles.faqList}>
              <li>{t('merchants.faqs.italianMarket.eligibleProducts.answer.notEligible.item1')}</li>
              <li>{t('merchants.faqs.italianMarket.eligibleProducts.answer.notEligible.item2')}</li>
              <li>{t('merchants.faqs.italianMarket.eligibleProducts.answer.notEligible.item3')}</li>
              <li>{t('merchants.faqs.italianMarket.eligibleProducts.answer.notEligible.item4')}</li>
              <li>{t('merchants.faqs.italianMarket.eligibleProducts.answer.notEligible.item5')}</li>
              <li>{t('merchants.faqs.italianMarket.eligibleProducts.answer.notEligible.item6')}</li>
            </ul>
          </div>
        </div>

        {/* Issue Invoice FAQ */}
        <div className={styles.faqItem}>
          <h2 className={styles.faqQuestion}>
            {t('merchants.faqs.italianMarket.issueInvoice.question')}
          </h2>
          <div className={styles.faqAnswer}>
            <p>{t('merchants.faqs.italianMarket.issueInvoice.answer.part1')}</p>
            <p>{t('merchants.faqs.italianMarket.issueInvoice.answer.part2')}</p>
            <p>{t('merchants.faqs.italianMarket.issueInvoice.answer.part3')}</p>

            <h3 className={styles.faqSubheading}>
              {t('merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.heading')}
            </h3>
            <div className={styles.invoiceType}>
              <h4>
                {t(
                  'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.realTaxFree.heading'
                )}
              </h4>
              <p>
                {t(
                  'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.realTaxFree.description'
                )}
              </p>
              <ul className={styles.faqList}>
                <li>
                  <strong>
                    {t(
                      'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.realTaxFree.approved.heading'
                    )}
                  </strong>
                  <ul>
                    <li>
                      {t(
                        'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.realTaxFree.approved.item1'
                      )}
                    </li>
                    <li>
                      {t(
                        'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.realTaxFree.approved.item2'
                      )}
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>
                    {t(
                      'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.realTaxFree.rejected.heading'
                    )}
                  </strong>
                  <ul>
                    <li>
                      {t(
                        'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.realTaxFree.rejected.item1'
                      )}
                    </li>
                    <li>
                      {t(
                        'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.realTaxFree.rejected.item2'
                      )}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className={styles.invoiceType}>
              <h4>
                {t(
                  'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.taxRefund.heading'
                )}
              </h4>
              <p>
                {t(
                  'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.taxRefund.description'
                )}
              </p>
              <ul className={styles.faqList}>
                <li>
                  <strong>
                    {t(
                      'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.taxRefund.approved.heading'
                    )}
                  </strong>
                  <ul>
                    <li>
                      {t(
                        'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.taxRefund.approved.item1'
                      )}
                    </li>
                    <li>
                      {t(
                        'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.taxRefund.approved.item2'
                      )}
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>
                    {t(
                      'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.taxRefund.rejected.heading'
                    )}
                  </strong>
                  <ul>
                    <li>
                      {t(
                        'merchants.faqs.italianMarket.issueInvoice.answer.invoiceTypes.taxRefund.rejected.item1'
                      )}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <p className={styles.note}>
              {t('merchants.faqs.italianMarket.issueInvoice.answer.note')}
            </p>
          </div>
        </div>

        {/* Receipt Required FAQ */}
        <div className={styles.faqItem}>
          <h2 className={styles.faqQuestion}>
            {t('merchants.faqs.italianMarket.receiptRequired.question')}
          </h2>
          <div className={styles.faqAnswer}>
            <p>{t('merchants.faqs.italianMarket.receiptRequired.answer.part1')}</p>
            <p>{t('merchants.faqs.italianMarket.receiptRequired.answer.part2')}</p>
            <p>{t('merchants.faqs.italianMarket.receiptRequired.answer.part3')}</p>
            <h3 className={styles.faqSubheading}>
              {t('merchants.faqs.italianMarket.receiptRequired.answer.whenToIssue.heading')}
            </h3>
            <p>
              {t('merchants.faqs.italianMarket.receiptRequired.answer.whenToIssue.description')}
            </p>
            <ul className={styles.faqList}>
              <li>{t('merchants.faqs.italianMarket.receiptRequired.answer.whenToIssue.item1')}</li>
              <li>{t('merchants.faqs.italianMarket.receiptRequired.answer.whenToIssue.item2')}</li>
            </ul>
            <p>{t('merchants.faqs.italianMarket.receiptRequired.answer.recommendation')}</p>
          </div>
        </div>

        {/* Customer Experience FAQ */}
        <div className={styles.faqItem}>
          <h2 className={styles.faqQuestion}>
            {t('merchants.faqs.italianMarket.customerExperience.question')}
          </h2>
          <div className={styles.faqAnswer}>
            <p>{t('merchants.faqs.italianMarket.customerExperience.answer.intro')}</p>

            <h3 className={styles.faqSubheading}>
              {t('merchants.faqs.italianMarket.customerExperience.answer.savings.heading')}
            </h3>
            <p>{t('merchants.faqs.italianMarket.customerExperience.answer.savings.description')}</p>

            <h3 className={styles.faqSubheading}>
              {t('merchants.faqs.italianMarket.customerExperience.answer.requiredInfo.heading')}
            </h3>
            <ul className={styles.faqList}>
              <li>
                {t('merchants.faqs.italianMarket.customerExperience.answer.requiredInfo.item1')}
              </li>
              <li>
                {t('merchants.faqs.italianMarket.customerExperience.answer.requiredInfo.item2')}
              </li>
              <li>
                {t('merchants.faqs.italianMarket.customerExperience.answer.requiredInfo.item3')}
              </li>
            </ul>

            <h3 className={styles.faqSubheading}>
              {t('merchants.faqs.italianMarket.customerExperience.answer.vatGuarantee.heading')}
            </h3>
            <p>
              {t('merchants.faqs.italianMarket.customerExperience.answer.vatGuarantee.description')}
            </p>
            <p>
              {t('merchants.faqs.italianMarket.customerExperience.answer.vatGuarantee.protection')}
            </p>

            <h3 className={styles.faqSubheading}>
              {t(
                'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.heading'
              )}
            </h3>
            <p>
              {t(
                'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.description'
              )}
            </p>

            <h4>
              {t(
                'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.euCustoms.heading'
              )}
            </h4>
            <ul className={styles.faqList}>
              <li>
                {t(
                  'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.euCustoms.item1'
                )}
              </li>
              <li>
                {t(
                  'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.euCustoms.item2'
                )}
              </li>
            </ul>

            <h4>
              {t(
                'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.outcomes.heading'
              )}
            </h4>
            <ul className={styles.faqList}>
              <li>
                <strong>
                  {t(
                    'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.outcomes.approved.heading'
                  )}
                </strong>
                {t(
                  'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.outcomes.approved.description'
                )}
              </li>
              <li>
                <strong>
                  {t(
                    'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.outcomes.rejected.heading'
                  )}
                </strong>
                {t(
                  'merchants.faqs.italianMarket.customerExperience.answer.customsValidation.outcomes.rejected.description'
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

// Spanish Market FAQs Component
function SpanishMarketFaqs() {
  const { t } = useTranslation();

  return (
    <>
      <section className={styles.header}>
        <h1 className={styles.heading}>{t('merchants.faqs.spanishMarket.heading')}</h1>
        <p className={styles.subheading}>{t('merchants.faqs.spanishMarket.subheading')}</p>
      </section>

      <div className={styles.faqContainer}>
        {/* Register Shop FAQ */}
        <div className={styles.faqItem}>
          <h2 className={styles.faqQuestion}>
            {t('merchants.faqs.spanishMarket.registerShop.question')}
          </h2>
          <div className={styles.faqAnswer}>
            <p>{t('merchants.faqs.spanishMarket.registerShop.answer.part1')}</p>
            <p>{t('merchants.faqs.spanishMarket.registerShop.answer.part2')}</p>
            <h3>{t('merchants.faqs.spanishMarket.registerShop.answer.requirements.heading')}</h3>
            <ul className={styles.faqList}>
              <li>{t('merchants.faqs.spanishMarket.registerShop.answer.requirements.item1')}</li>
              <li>{t('merchants.faqs.spanishMarket.registerShop.answer.requirements.item2')}</li>
            </ul>
            <p>{t('merchants.faqs.spanishMarket.registerShop.answer.conclusion')}</p>
          </div>
        </div>

        {/* Issue Invoice FAQ */}
        <div className={styles.faqItem}>
          <h2 className={styles.faqQuestion}>
            {t('merchants.faqs.spanishMarket.issueInvoice.question')}
          </h2>
          <div className={styles.faqAnswer}>
            <p>{t('merchants.faqs.spanishMarket.issueInvoice.answer.part1')}</p>
            <p>{t('merchants.faqs.spanishMarket.issueInvoice.answer.part2')}</p>
            <p>{t('merchants.faqs.spanishMarket.issueInvoice.answer.part3')}</p>

            <h3 className={styles.faqSubheading}>
              {t('merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.heading')}
            </h3>
            <div className={styles.invoiceType}>
              <h4>
                {t(
                  'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.realTaxFree.heading'
                )}
              </h4>
              <p>
                {t(
                  'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.realTaxFree.description'
                )}
              </p>
              <ul className={styles.faqList}>
                <li>
                  <strong>
                    {t(
                      'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.realTaxFree.approved.heading'
                    )}
                  </strong>
                  <ul>
                    <li>
                      {t(
                        'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.realTaxFree.approved.item1'
                      )}
                    </li>
                    <li>
                      {t(
                        'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.realTaxFree.approved.item2'
                      )}
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>
                    {t(
                      'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.realTaxFree.rejected.heading'
                    )}
                  </strong>
                  <ul>
                    <li>
                      {t(
                        'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.realTaxFree.rejected.item1'
                      )}
                    </li>
                    <li>
                      {t(
                        'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.realTaxFree.rejected.item2'
                      )}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className={styles.invoiceType}>
              <h4>
                {t(
                  'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.taxRefund.heading'
                )}
              </h4>
              <p>
                {t(
                  'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.taxRefund.description'
                )}
              </p>
              <ul className={styles.faqList}>
                <li>
                  <strong>
                    {t(
                      'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.taxRefund.approved.heading'
                    )}
                  </strong>
                  <ul>
                    <li>
                      {t(
                        'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.taxRefund.approved.item1'
                      )}
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>
                    {t(
                      'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.taxRefund.rejected.heading'
                    )}
                  </strong>
                  <ul>
                    <li>
                      {t(
                        'merchants.faqs.spanishMarket.issueInvoice.answer.invoiceTypes.taxRefund.rejected.item1'
                      )}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <p className={styles.note}>
              {t('merchants.faqs.spanishMarket.issueInvoice.answer.note')}
            </p>
          </div>
        </div>

        {/* No Receipt Required FAQ for Spanish market */}

        {/* Customer Experience FAQ */}
        <div className={styles.faqItem}>
          <h2 className={styles.faqQuestion}>
            {t('merchants.faqs.spanishMarket.customerExperience.question')}
          </h2>
          <div className={styles.faqAnswer}>
            <p>{t('merchants.faqs.spanishMarket.customerExperience.answer.intro')}</p>

            <h3 className={styles.faqSubheading}>
              {t('merchants.faqs.spanishMarket.customerExperience.answer.savings.heading')}
            </h3>
            <p>{t('merchants.faqs.spanishMarket.customerExperience.answer.savings.description')}</p>

            <h3 className={styles.faqSubheading}>
              {t('merchants.faqs.spanishMarket.customerExperience.answer.requiredInfo.heading')}
            </h3>
            <ul className={styles.faqList}>
              <li>
                {t('merchants.faqs.spanishMarket.customerExperience.answer.requiredInfo.item1')}
              </li>
              <li>
                {t('merchants.faqs.spanishMarket.customerExperience.answer.requiredInfo.item2')}
              </li>
              <li>
                {t('merchants.faqs.spanishMarket.customerExperience.answer.requiredInfo.item3')}
              </li>
            </ul>

            <h3 className={styles.faqSubheading}>
              {t('merchants.faqs.spanishMarket.customerExperience.answer.vatGuarantee.heading')}
            </h3>
            <p>
              {t('merchants.faqs.spanishMarket.customerExperience.answer.vatGuarantee.description')}
            </p>
            <p>
              {t('merchants.faqs.spanishMarket.customerExperience.answer.vatGuarantee.protection')}
            </p>

            <h3 className={styles.faqSubheading}>
              {t(
                'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.heading'
              )}
            </h3>
            <p>
              {t(
                'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.description'
              )}
            </p>

            <h4>
              {t(
                'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.euCustoms.heading'
              )}
            </h4>
            <ul className={styles.faqList}>
              <li>
                {t(
                  'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.euCustoms.item1'
                )}
              </li>
              <li>
                {t(
                  'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.euCustoms.item2'
                )}
              </li>
            </ul>

            <h4>
              {t(
                'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.outcomes.heading'
              )}
            </h4>
            <ul className={styles.faqList}>
              <li>
                <strong>
                  {t(
                    'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.outcomes.approved.heading'
                  )}
                </strong>
                {t(
                  'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.outcomes.approved.description'
                )}
              </li>
              <li>
                <strong>
                  {t(
                    'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.outcomes.rejected.heading'
                  )}
                </strong>
                {t(
                  'merchants.faqs.spanishMarket.customerExperience.answer.customsValidation.outcomes.rejected.description'
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

// Client Component that uses useSearchParams
function FaqsContent() {
  const searchParams = useSearchParams();
  const market = searchParams.get('market');

  return (
    <main className={styles.container}>
      {market === 'it' ? <ItalianMarketFaqs /> : <SpanishMarketFaqs />}
    </main>
  );
}

// Main FAQs Component with Suspense boundary
export default function Faqs() {
  return (
    <Suspense fallback={<div className={styles.container}>Loading...</div>}>
      <FaqsContent />
    </Suspense>
  );
}
